import { useEffect, useState, useCallback } from 'react';
import { firebaseService } from '../services/firebase';
import { WeatherData } from '../types/weather';
import { FirebaseReading } from '../types/firebase';

export const useFirebase = () => {
  const [initialized, setInitialized] = useState(false);
  const [historicalData, setHistoricalData] = useState<FirebaseReading[]>([]);

  useEffect(() => {
    firebaseService.initialize();
    setInitialized(firebaseService.isInitialized());
  }, []);

  const saveReading = useCallback(async (data: WeatherData) => {
    const timestamp =
      typeof data.timestamp === 'number' || typeof data.timestamp === 'string'
        ? data.timestamp
        : Date.now();
    await firebaseService.saveReading({ ...data, timestamp });
  }, []);

  // Listen for live readings saved anywhere (e.g., MQTT path) and append locally
  useEffect(() => {
    const off = firebaseService.onLiveReading((reading) => {
      setHistoricalData((prev) => {
        const next = [...prev, reading];
        if (next.length > 1000) next.splice(0, next.length - 1000);
        return next;
      });
    });
    return off;
  }, []);

  const loadHistoricalData = useCallback(async (hours: number = 24) => {
    const data = await firebaseService.getHistoricalData(hours);
    setHistoricalData(data);
    return data;
  }, []);

  return {
    initialized,
    historicalData,
    saveReading,
    loadHistoricalData,
  };
};
